import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function ReviewIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Review</title>
      <g>
        <path d="M50 5H10C7.25 5 5.025 7.25 5.025 10L5 55L15 45H50C52.75 45 55 42.75 55 40V10C55 7.25 52.75 5 50 5ZM15 35V28.825L32.2 11.625C32.7 11.125 33.475 11.125 33.975 11.625L38.4 16.05C38.9 16.55 38.9 17.325 38.4 17.825L21.175 35H15ZM45 35H26.25L31.25 30H45V35Z" />
      </g>
    </SvgIcon>
  );
}

export default ReviewIcon;
